import React, { useState } from "react";
import axios from "../../API/axios";
import { NewsFeed, people } from "../../config/imagesLink";
import PortalEmojiPicker from "../../components/PortalEmojiPicker";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import { useTranslation } from "react-i18next";
const SingleCommentReply = ({
  item,
  postId,
  postList,
  setPostList,
  toggleReplyComment,
  AllPostList,
  setSinglePostCommentList,
  singlepostCommentList,
  singlepostList,
  setSinglePostList,
  singlepostListinfo,
  setSinglePostListInfo,
  focusTrigger,
}) => { 

  const sessionId = localStorage.getItem("sessionId");
  const profilPic = localStorage.getItem("profilPic");
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************Post Comment  ************************//
  const [content, setContent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiAnchorRef = React.useRef(null);
  // console.log("content:", content);
 
  // const postData = async () => {
  //   const postdatadetails = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     pstCmntId: item?.pstCmntId,
  //     reply: content,
  //   }; 
  
  //   if (content === "") {
  //     setWarningToastMessage("Please Add the Comment");
  //     setShowWarningToast(true);
  //     return;
  //   }
  //   try {
  //     const res = await axios.post("PostAction/CommentReply", postdatadetails);
  //     setShowToast(true);
  //     setToastMessage(res.data.message);
  //     AllPostList();
      
  //     setContent("");
  //     toggleReplyComment(); //hide reply input
  //    const resp = res?.data?.responseData;
       
  //      const newComment = {
  //         pstCmntId: resp?.pstCmntId ?? resp?.pstCommentId ?? resp?.pstCmntId ?? null,
  //         // comment: resp?.comment ?? postInputValue ?? "",
  //         // dynamicValues: resp?.dynamicValues ?? postDynamicValues ?? null,
  //         likeCount: resp?.likeCount ?? 0,
  //         replyCount: resp?.replyCount ?? 0,
  //         isOwned: true,
  //         isLiked: resp?.isLiked ?? false,
  //         likedType: resp?.likedType ?? null,
  //         likedTypeGif: resp?.likedTypeGif ?? null,
  //         useruid: resp?.useruid ?? localStorage.getItem("userUid") ?? null,
  //         userName: resp?.userName ?? localStorage.getItem("userName") ?? "",
  //         userAvatar: profilPic,
  //         creationTime: resp?.creationTime ?? new Date().toISOString(),
  //         commentsReplies: resp?.commentsReplies ?? []
  //       };

  //     // const updatedPost = postDetailsResponse.data.responseData.postInfo; 
  //       setSinglePostCommentList((prev = []) => [newComment, ...prev]);
     
  //   // setSinglePostListInfo((prev) => ({
  //   //   ...prev,
  //   //   postInfo: {
  //   //     ...updatedPost,
  //   //   },
  //   // }));

  //    // Update the existing post in the list
  //     setPostList((prev) =>
  //       Array.isArray(prev) ?
  //       prev?.map((post) =>
  //         post.postId === newComment.postId ? newComment : post
  //       )
  //       : []
  //     );
     
  //   } catch (error) {
  //     setErrorToastMessage(error.message);
  //     setShowErrorToast(true);
  //   }
  // };
 
  const postData = async () => {
  const postdatadetails = {
    deviceType: "Web",
    sessionId: sessionId,
    pstCmntId: item?.pstCmntId, // parent comment ID
    reply: content,
          langKey: language === "en" ? "" : language,

  };

  if (content === "") {
    setWarningToastMessage("Please Add the Comment");
    setShowWarningToast(true);
    return;
  }

  try {
    const res = await axios.post("PostAction/CommentReply", postdatadetails);
    setShowToast(true);
    setToastMessage(res.data.message);
    setContent("");
    toggleReplyComment(); // hide reply input

    const resp = res?.data?.responseData;
    console.log("NewpstCmntRpIyId", resp.pstCmntRplyId);
    // localStorage.setItem("NewpstCmntRpIyId", resp.pstCmntRplyId);

    const newReply = {
      pstCmntRpIyId: resp?.pstCmntRpIyId ?? null,
      reply: resp?.reply ?? content,
      likeCount: resp?.likeCount ?? 0,
      replyCount: 0,
      isOwned: true,
      isLiked: resp?.isLiked ?? false,
      likedType: resp?.likedType ?? null,
      likedTypeGif: resp?.likedTypeGif ?? null,
      useruid: resp?.userid ?? localStorage.getItem("userUid") ?? null,
      userName: resp?.userName ?? localStorage.getItem("userName") ?? "",
      userAvatar:  profilPic,
      creationTime: resp?.creationTime  ,
    };

    // ✅ Update single post comment list
    setSinglePostCommentList((prev = []) =>
      prev.map((comment) => {
        if (comment.pstCmntId === item?.pstCmntId) {
          return {
            ...comment,
            replyCount: (comment.replyCount || 0) + 1,
            commentsReplies: [newReply, ...(comment.commentsReplies || [])],
          };
        }
        return comment;
      })
    );

    // ✅ Update full post list
    if (typeof setPostList === "function") {
      setPostList((prevList = []) =>
        prevList.map((post) =>
          post.postInfo?.postId === postId
            ? {
                ...post,
                postInfo: {
                  ...post.postInfo,
                  comments: post.postInfo.comments?.map((comment) =>
                    comment.pstCmntId === item?.pstCmntId
                      ? {
                          ...comment,
                          replyCount: (comment.replyCount || 0) + 1,
                          commentsReplies: [
                            newReply,
                            ...(comment.commentsReplies || []),
                          ],
                        }
                      : comment
                  ),
                  commentCount: (post.postInfo.commentCount || 0) + 1,
                },
              }
            : post
        )
      );
    }
  } catch (error) {
    setErrorToastMessage(error.message);
    setShowErrorToast(true);
  }
};


//   const postData = async () => {
//   const postdatadetails = {
//     deviceType: "Web",
//     sessionId: sessionId,
//     pstCmntId: item?.pstCmntId, // parent comment ID
//     reply: content,
//   };

//   if (content === "") {
//     setWarningToastMessage("Please Add the Comment");
//     setShowWarningToast(true);
//     return;
//   }

//   try {
//     const res = await axios.post("PostAction/CommentReply", postdatadetails);
//     setShowToast(true);
//     setToastMessage(res.data.message);
//     setContent("");
//     toggleReplyComment(); // hide reply input

//     const resp = res?.data?.responseData;

//     const newReply = {
//       pstCmntId: resp?.pstCmntId ?? null,
//       reply: resp?.reply ?? content,
//       likeCount: resp?.likeCount ?? 0,
//       replyCount: 0,
//       isOwned: true,
//       isLiked: resp?.isLiked ?? false,
//       likedType: resp?.likedType ?? null,
//       likedTypeGif: resp?.likedTypeGif ?? null,
//       useruid: resp?.useruid ?? localStorage.getItem("userUid") ?? null,
//       userName: resp?.userName ?? localStorage.getItem("userName") ?? "",
//       userAvatar: profilPic,
//       creationTime: resp?.creationTime ?? new Date().toISOString(),
//       commentsReplies: [],
//     };

//     // ✅ Update state without API call
//     setSinglePostCommentList((prev = []) =>
//       prev.map((comment) => {
//         if (comment.pstCmntId === item?.pstCmntId) {
//           return {
//             ...comment,
//             replyCount: (comment.replyCount || 0) + 1,
//             commentsReplies: [newReply, ...(comment.commentsReplies || [])],
//           };
//         }
//         return comment;
//       })
//     );
//   } catch (error) {
//     setErrorToastMessage(error.message);
//     setShowErrorToast(true);
//   }
// };

  const handleKeyPress = () => {
    postData();
  };
  const handleEmojiClick = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const handleEmojiClose = () => {
    setShowEmojiPicker(false);
  };
  //************************Post Comment  ************************//
  // const profilPic = localStorage.getItem("profilPic");
  const guestModeData = localStorage.getItem("guestMode");

  React.useEffect(() => {
    if (editorRef.current) {
      editorRef.current.focus();
      const textLength = editorRef.current.value?.length || 0;
      editorRef.current.setSelectionRange(textLength, textLength);
    }
  }, [focusTrigger]);

  const editorRef = React.useRef(null);
  return (
    <>
      {guestModeData === "true" ? (
        ""
      ) : (
        <div className="ReplyComment mt-2">
          <div className="commentArea ">
            <div className="ImgAvatar1">
              <img src={profilPic} alt="" style={{ borderRadius: "50px" }} />
            </div>
            <div className="commentBox">
              <input
              style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
              ref={editorRef}
              autoFocus
              className="me-2 ps-2"
                type="text"
                placeholder={t("Newsfeed.Write your comment")}
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleKeyPress();
                  }
                }}
              />
              <div className="commentBox-actions">
                <span ref={emojiAnchorRef} className="wlj-emoji-anchor">
                  <AddReactionSharpIcon
                    className="material-symbols-sharp"
                    onClick={handleEmojiClick}
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <SendSharpIcon
                  className="material-symbols-sharp"
                  onClick={() => postData()}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
          <PortalEmojiPicker
            show={showEmojiPicker}
            anchorRef={emojiAnchorRef}
            onClose={handleEmojiClose}
            onEmojiClick={(emojiData) => {
              setContent((prev) => prev + emojiData.emoji);
              setShowEmojiPicker(false);
            }}
          />
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default SingleCommentReply;
